module.exports = __webpack_public_path__ + "static/img/theme_01.294ef9d5.png";